import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import appStore from "./utils/appStore";
import "./components/brands/BrandDetails.scss";
import "./components/campaigns/Campaign.scss";
import "./components/create-user/UserList.scss";
import "./components/dashboard/Dashboard.scss";
import "./components/influencer-profile/InfluencerProfile.scss";
import "./components/influencers/Influencers.scss";
import "./components/influencers/TableLoader.scss";
import "./components/settings/Settings.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={appStore}>
    <App />
  </Provider>
  // </React.StrictMode>
);

reportWebVitals();
